import AdminDeviceDetail from './AdminDeviceDetail'
export default AdminDeviceDetail
